import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const { user, initializing } = useAuth();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const paymentId = params.get("payment_id");
  const provider = params.get("provider");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (initializing) return;
    if (!paymentId) {
      setState("missing");
      return;
    }
    if (!user) {
      try {
        sessionStorage.setItem(
          "post_login_redirect",
          `/payment/success?payment_id=${encodeURIComponent(paymentId)}&provider=${encodeURIComponent(provider || "")}`
        );
      } catch {}
      nav("/login", { replace: true });
      return;
    }

    let cancelled = false;
    let attempts = 0;
    let timer;

    const check = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/${encodeURIComponent(paymentId)}/status`);
        if (cancelled) return;
        if (data?.status === "paid" && data?.access_granted && data?.target) {
          setState("ready");
          timer = window.setTimeout(() => nav(data.target, { replace: true }), 900);
          return;
        }
        if (data?.status === "failed") {
          setState("failed");
          return;
        }
      } catch {
        // Webhook confirmation can arrive a little after the browser redirect.
      }
      if (attempts < 20 && !cancelled) {
        timer = window.setTimeout(check, 1500);
      } else if (!cancelled) {
        setState("waiting");
      }
    };

    check();
    return () => {
      cancelled = true;
      if (timer) window.clearTimeout(timer);
    };
  }, [initializing, user, paymentId, provider, nav]);

  const title = state === "ready"
    ? "Оплата подтверждена"
    : state === "failed"
      ? "Платёж не подтверждён"
      : "Подтверждаем оплату";

  return (
    <main className="min-h-screen bg-[#21150D] text-[#F5EAD8] flex items-center justify-center px-6">
      <section className="w-full max-w-xl text-center">
        <div className="text-xs uppercase tracking-[0.25em] text-[#C9A84C]">Anokina Studio</div>
        <h1 className="font-serif text-4xl mt-4">{title}</h1>

        {state === "ready" && (
          <p className="mt-5 text-[#F5EAD8]/75">Доступ открыт. Перенаправляем Вас к приобретённому продукту…</p>
        )}
        {state === "checking" && (
          <p className="mt-5 text-[#F5EAD8]/70">Ждём защищённое подтверждение от платёжной системы. Обычно это занимает несколько секунд.</p>
        )}
        {state === "waiting" && (
          <p className="mt-5 text-[#F5EAD8]/70">
            Платёж ещё обрабатывается. Если деньги списаны, не оплачивайте повторно — доступ откроется после подтверждения webhook.
          </p>
        )}
        {state === "failed" && (
          <p className="mt-5 text-[#F3C7B5]">Платёжная система не подтвердила успешную оплату.</p>
        )}
        {state === "missing" && (
          <p className="mt-5 text-[#F3C7B5]">Не найден идентификатор платежа.</p>
        )}

        {(state === "waiting" || state === "failed" || state === "missing") && (
          <Link to="/programs" className="inline-block mt-8 underline underline-offset-4">
            Вернуться к программам
          </Link>
        )}
      </section>
    </main>
  );
}
